// APP
export const APP_INIT_START = 'APP_INIT_START';
export const APP_INIT_SUCCESS = 'APP_INIT_SUCCESS';
export const APP_INIT_FAILED = 'APP_INIT_FAILED';

// PSAP

export const GET_PSAP_INFO_START = 'GET_PSAP_INFO_START';
export const GET_PSAP_INFO_SUCCESS = 'GET_PSAP_INFO_SUCCESS';
export const GET_PSAP_INFO_FAILED = 'GET_PSAP_INFO_FAILED';

export const UPDATE_PSAP_INFO_START = 'UPDATE_PSAP_INFO_START';
export const UPDATE_PSAP_INFO_SUCCESS = 'UPDATE_PSAP_INFO_SUCCESS';
export const UPDATE_PSAP_INFO_FAILED = 'UPDATE_PSAP_INFO_FAILED';

// ISSUES

export const FETCH_ISSUES_START = 'FETCH_ISSUES_START';
export const FETCH_ISSUES_SUCCESS = 'FETCH_ISSUES_SUCCESS';
export const FETCH_ISSUES_FAILED = 'FETCH_ISSUES_FAILED';

export const CREATE_ISSUE_START = 'CREATE_ISSUE_START';
export const CREATE_ISSUE_SUCCESS = 'CREATE_ISSUE_SUCCESS';
export const CREATE_ISSUE_FAILED = 'CREATE_ISSUE_FAILED';

export const UPDATE_ISSUE_START = 'UPDATE_ISSUE_START';
export const UPDATE_ISSUE_SUCCESS = 'UPDATE_ISSUE_SUCCESS';
export const UPDATE_ISSUE_FAILED = 'UPDATE_ISSUE_FAILED';

export const DELETE_ISSUE_START = 'DELETE_ISSUE_START';
export const DELETE_ISSUE_SUCCESS = 'DELETE_ISSUE_SUCCESS';
export const DELETE_ISSUE_FAILED = 'DELETE_ISSUE_FAILED';

export const CREATE_ISSUE_COMMENT_START = 'CREATE_ISSUE_COMMENT_START';
export const CREATE_ISSUE_COMMENT_SUCCESS = 'CREATE_ISSUE_COMMENT_SUCCESS';
export const CREATE_ISSUE_COMMENT_FAILED = 'CREATE_ISSUE_COMMENT_FAILED';
